import React from 'react';

const AddMemberConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/members/add',
            exact: true,
			component: React.lazy(() => import('./AddMember'))
		}
	]
};

export default AddMemberConfig;
